/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_2_BodyInputs */

const en_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicated chipping and pitching zones plus multiple practice greens. Dial in wedges and putting between range sessions.`)
};

const es_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonas dedicadas para chips y pitches, además de varios greens de práctica. Afina tus wedges y tu putt entre sesiones en el campo de práctica.`)
};

const de_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Zonen für Chips und Pitches sowie mehrere Übungsgrüns. Feilen Sie zwischen Ihren Range-Einheiten an Wedges und Putts.`)
};

const zh_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专门的切杆和劈起杆区域，另有多个练习果岭。在练习场训练间隙打磨挖起杆和推杆。`)
};

const ar_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مناطق مخصصة لضربات التشيب والبيتش إلى جانب عدة ملاعب خضراء للتدريب. اضبط ضربات الويدج والبَت بين جلسات التدريب في الميدان.`)
};

const fr_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des zones dédiées aux chips et aux pitchs, plus plusieurs greens d'entraînement. Peaufinez vos wedges et votre putting entre deux séances au practice.`)
};

const vi_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khu riêng cho cú chip và pitch cùng nhiều green tập. Mài giũa cú wedge và putt giữa các buổi tập ở sân tập.`)
};

const sw_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maeneo maalumu ya chip na pitch pamoja na grini kadhaa za mazoezi. Boresha mipigo ya wedge na putting kati ya vipindi vya mazoezi uwanjani.`)
};

const th_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โซนเฉพาะสำหรับการชิพและพิทช์ พร้อมกรีนซ้อมหลายกรีน ฝึกเวดจ์และพัตต์ให้แม่นขึ้นระหว่างรอบซ้อมที่ไดรฟ์กอล์ฟ`)
};

const bs_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posebne zone za chip i pitch udarce te više greenova za vježbu. Izbrusite udarce wedgeom i putting između treninga na vježbalištu.`)
};

const ja_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップとピッチ専用のゾーンに加え、複数の練習グリーン。レンジ練習の合間にウェッジとパッティングを磨けます。`)
};

const ko_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`칩샷과 피치샷 전용 구역과 여러 개의 연습 그린이 있습니다. 레인지 연습 사이사이에 웨지 샷과 퍼팅을 다듬으세요.`)
};

const pt_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áreas dedicadas a chips e pitches, além de vários greens de treino. Aperfeiçoe seus wedges e seu putt entre as sessões no driving range.`)
};

const it_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone dedicate a chip e pitch, più diversi green di pratica. Affina wedge e putt tra una sessione al campo pratica e l'altra.`)
};

const sv_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Särskilda zoner för chippar och pitchar samt flera träningsgreener. Finslipa wedgeslag och puttning mellan passen på drivingrangen.`)
};

const nl_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speciale zones voor chips en pitches, plus meerdere oefengreens. Verfijn je wedges en putts tussen je sessies op de driving range.`)
};

const da_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Særlige zoner til chip og pitch samt flere træningsgreens. Finpuds wedgeslag og putning mellem dine sessioner på driving rangen.`)
};

const nb_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egne soner for chip og pitch, i tillegg til flere treningsgreener. Finpuss wedgeslag og putting mellom øktene på drivingrangen.`)
};

const fi_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omat alueet chippeihin ja pitcheihin sekä useita harjoitusviheriöitä. Hio wedge-lyöntejä ja puttaamista rangeharjoitusten välillä.`)
};

const pl_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydzielone strefy do chipów i pitchy oraz kilka greenów treningowych. Dopracuj uderzenia wedgem i putting między sesjami na driving range.`)
};

const ru_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдельные зоны для чипов и питчей, а также несколько тренировочных гринов. Оттачивайте удары веджами и патт между тренировками на драйвинг-рейндже.`)
};

const tr_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chip ve pitch vuruşlarına ayrılmış bölgeler ile birden fazla antrenman greeni. Driving range seanslarının arasında wedge vuruşlarınızı ve puttlarınızı geliştirin.`)
};

const hi_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चिपिंग और पिचिंग के लिए अलग क्षेत्र और कई प्रैक्टिस ग्रीन। रेंज सत्रों के बीच अपने वेज और पटिंग को निखारें।`)
};

const id_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona khusus untuk chip dan pitch, ditambah beberapa green latihan. Asah pukulan wedge dan putting Anda di sela sesi di lapangan latihan.`)
};

const ms_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zon khas untuk pukulan chip dan pitch serta beberapa green latihan. Asah pukulan wedge dan putting anda antara sesi latihan di lapang latihan.`)
};

const cs_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhrazené zóny pro chipy a pitche a několik cvičných greenů. Vylaďte wedge a patování mezi tréninky na driving range.`)
};

const el_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ειδικές ζώνες για chip και pitch, καθώς και πολλά γκριν εξάσκησης. Τελειοποιήστε τα wedge και το πατ ανάμεσα στις προπονήσεις σας στο driving range.`)
};

const he_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אזורים ייעודיים לצ'יפים ולפיצ'ים וכמה גרינים לאימון. שפרו את חבטות הוודג' והפאטינג בין האימונים במגרש האימונים.`)
};

const af_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegewyde areas vir chip- en pitchhoue, plus verskeie oefengreens. Slyp jou wedge- en putwerk tussen oefensessies op die oefenbaan.`)
};

const hu_range_content_feature_2_body = /** @type {(inputs: Range_Content_Feature_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Külön zónák chipekhez és pitchekhez, valamint több gyakorlógreen. Csiszold a wedge-ütéseidet és a puttolást a range-edzések között.`)
};

/**
* | output |
* | --- |
* | "Dedicated chipping and pitching zones plus multiple practice greens. Dial in wedges and putting between range sessions." |
*
* @param {Range_Content_Feature_2_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_2_body = /** @type {((inputs?: Range_Content_Feature_2_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_2_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_2_body(inputs)
	if (locale === "de") return de_range_content_feature_2_body(inputs)
	if (locale === "zh") return zh_range_content_feature_2_body(inputs)
	if (locale === "ar") return ar_range_content_feature_2_body(inputs)
	if (locale === "fr") return fr_range_content_feature_2_body(inputs)
	if (locale === "vi") return vi_range_content_feature_2_body(inputs)
	if (locale === "sw") return sw_range_content_feature_2_body(inputs)
	if (locale === "th") return th_range_content_feature_2_body(inputs)
	if (locale === "bs") return bs_range_content_feature_2_body(inputs)
	if (locale === "ja") return ja_range_content_feature_2_body(inputs)
	if (locale === "ko") return ko_range_content_feature_2_body(inputs)
	if (locale === "pt") return pt_range_content_feature_2_body(inputs)
	if (locale === "it") return it_range_content_feature_2_body(inputs)
	if (locale === "sv") return sv_range_content_feature_2_body(inputs)
	if (locale === "nl") return nl_range_content_feature_2_body(inputs)
	if (locale === "da") return da_range_content_feature_2_body(inputs)
	if (locale === "nb") return nb_range_content_feature_2_body(inputs)
	if (locale === "fi") return fi_range_content_feature_2_body(inputs)
	if (locale === "pl") return pl_range_content_feature_2_body(inputs)
	if (locale === "ru") return ru_range_content_feature_2_body(inputs)
	if (locale === "tr") return tr_range_content_feature_2_body(inputs)
	if (locale === "hi") return hi_range_content_feature_2_body(inputs)
	if (locale === "id") return id_range_content_feature_2_body(inputs)
	if (locale === "ms") return ms_range_content_feature_2_body(inputs)
	if (locale === "cs") return cs_range_content_feature_2_body(inputs)
	if (locale === "el") return el_range_content_feature_2_body(inputs)
	if (locale === "he") return he_range_content_feature_2_body(inputs)
	if (locale === "af") return af_range_content_feature_2_body(inputs)
	if (locale === "hu") return hu_range_content_feature_2_body(inputs)
	return en_range_content_feature_2_body(inputs)
});